export default "__VITE_ASSET__o5iP$ZbY__"